import { SearchTag } from 'frontend/types'
import DeleteCross from 'assets/icons/tag-delete-cross.svg'
import styles from './SearchTags.module.css'
import { searchTagClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import { SearchParams } from 'backend/services/types/urApiService.types'

interface Props {
  searchTags: SearchTag[]
  updateSearch: (params: SearchParams, shouldReset?: boolean) => Promise<void>
}

const SearchTags = ({ searchTags, updateSearch }: Props) => {
  return (
    <div className={styles.tagWrapper}>
      {searchTags.map((tag, index) => (
        <button
          className={styles.tag}
          key={index}
          onClick={() => {
            searchTagClick(tag.label)
            updateSearch({ [tag.queryKey]: tag.queryValue })
          }}
        >
          <span className={styles.tagLabel}>{tag.label}</span>
          <DeleteCross className={styles.deleteIcon} />
        </button>
      ))}
      <button
        className={styles.tag}
        onClick={() => {
          searchTagClick('Rensa filter')
          updateSearch({}, true)
        }}
      >
        Rensa filter
      </button>
    </div>
  )
}

export default SearchTags
